/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import ButtonBreadcrumbUnder from 'DesignSystem/ButtonBreadcrumbUnder/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/Patients/Content/Breadcrumb/ImageSeries/ImageSeries/Content"
  
}) {
let patientDocumentsSelectedImageSeriesNameValueData = fromData.useDataValue({ viewPath,
context: 'patient_documents',
path: 'selected_image_series.name',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 width={14}
 height={14}
 marginLeft={16}
 marginRight={16}
 stroke="rgba(0,0,0,0.3)"
/>
<ButtonBreadcrumbUnder
  viewPath={`${viewPath}/ButtonBreadcrumbUnder`}
 data="patient_documents.selected_image_series.name"
 text={patientDocumentsSelectedImageSeriesNameValueData}
/>
</div>
{children}
</React.Fragment>)
}